<template>
    <q-page padding class="docs-input row justify-center divimage">
        <div class="auth shadow-10">
            <div class = "q-ma-md" align="center">
                <p class="caption" >{{$t('regtitle')}}</p>
                <q-field :label="$t('usertype')" style="font-size:10pt;" :label-width="4">
                    <q-select 
                        v-model="form.usertype" 
                        style="text-align:left;"
                        :options="[ 
                            { label: $t('doctor'), value: 'doctor'},
                            { label: $t('patient'), value: 'patient'}
                        ]"
                    />
                </q-field>

                <q-field :label="$t('lastname')" style="font-size:10pt;" :label-width="4" >
                    <q-input 
                        v-model="form.lastname" 
                        style="text-align:left;"
                        :error="$v.form.lastname.$error"
                    />
                </q-field>

                <q-field :label="$t('firstname')" style="font-size:10pt;" :label-width="4">
                    <q-input 
                        v-model="form.firstname" 
                        style="text-align:left;"
                        :error="$v.form.firstname.$error"
                    />
                </q-field>

                <q-field :label="$t('surname')" style="font-size:10pt;" :label-width="4">
                    <q-input 
                        v-model="form.surname" 
                        style="text-align:left;"
                        :error="$v.form.surname.$error"
                    />
                </q-field>

                <q-field :label="$t('email')" style="font-size:10pt;" :label-width="4">
                    <q-input 
                        v-model="form.email" 
                        style="text-align:left;"
                        :error="$v.form.email.$error"
                    />
                </q-field>

                <q-field :label="$t('phone')" style="font-size:10pt;" :label-width="4">
                    <q-input 
                        v-model="form.phone" 
                        style="text-align:left;"
                        :error="$v.form.phone.$error"
                        prefix="+7"
                        maxlength="15"
                    />
                </q-field>

                <q-field :label="$t('pass')" style="font-size:10pt;" :label-width="4">
                    <q-input 
                        type="password" 
                        v-model="form.password" 
                        @keyup.enter="submit" 
                        style="text-align:left;"
                        :error="$v.form.password.$error"
                    />
                </q-field>            
                <q-field :label="$t('passcnf')" style="font-size:10pt;" :label-width="4">
                    <q-input 
                        type="password" 
                        v-model="form.passwordcnf" 
                        @keyup.enter="submit" 
                        style="text-align:left;"
                        :error="$v.form.passwordcnf.$error"
                    />
                </q-field>
                <q-btn color="primary" class = "q-ma-lg" @click="submit">{{$t('regbtn')}}</q-btn>
            </div>
        </div>
    </q-page>
</template>

<script>
import { required, email, numeric, sameAs, minLength } from 'vuelidate/lib/validators'
import axios from 'axios'
import VMasker from 'vanilla-masker'

export default {
    data () {
        return {
            form: {
                firstname: '',
                lastname: '',
                surname:'',
                phone: '',
                email: '',
                password: '',
                passwordcnf: '',
                usertype: 'doctor'
            }
        }
    },
    validations: {
        form: {
            firstname: { required },
            lastname: { required },
            surname: { required },
            phone: { required },
            email: { required, email  },
            password: { required, minLength: minLength(6) },
            passwordcnf: { sameAsPassword:sameAs('password') }
        }
    },
    watch: {
        'form.phone' (newVal, oldVal) {
        this.form.phone = VMasker.toPattern(newVal, '(999) 999-99-99')
        }
    },  
    methods: {
        submit () {
        this.$v.form.$touch()
        if (this.$v.form.$error) {
            if (this.$v.form.lastname.$error) {
                if (!this.$v.form.lastname.required)
                    this.$q.notify({ message:this.$t('errors.lastnameempty'),type: 'negative', icon: 'report_problem' })
            }

            if (this.$v.form.firstname.$error) {
                if (!this.$v.form.firstname.required)
                    this.$q.notify({ message:this.$t('errors.firstnameempty'),type: 'negative', icon: 'report_problem' })
            }

            if (this.$v.form.surname.$error) {
                if (!this.$v.form.surname.required)
                    this.$q.notify({ message:this.$t('errors.surnameempty'),type: 'negative', icon: 'report_problem' })
            }

            if (this.$v.form.email.$error) {
                if (!this.$v.form.email.required)
                    this.$q.notify({ message:this.$t('errors.emailempty'),type: 'negative', icon: 'report_problem' })
                if (!this.$v.form.email.email)
                    this.$q.notify({ message:this.$t('errors.emailnotvalid'),type: 'negative', icon: 'report_problem' })
            }

            if (this.$v.form.phone.$error) {
                if (!this.$v.form.phone.required)
                    this.$q.notify({ message:this.$t('errors.phoneempty'),type: 'negative', icon: 'report_problem' })
            }

            if (this.$v.form.password.$error) {
                if (!this.$v.form.password.required)
                    this.$q.notify({ message:this.$t('errors.passempty'),type: 'negative', icon: 'report_problem' })
                if (!this.$v.form.password.minLength)
                    this.$q.notify({ message:this.$t('errors.passsimple'),type: 'negative', icon: 'report_problem' })
            }

            if (this.$v.form.passwordcnf.$error) {
                if (!this.$v.form.passwordcnf.sameAs)
                    this.$q.notify({ message:this.$t('errors.passcnferr'),type: 'negative', icon: 'report_problem' })
            }
            return
        } 

        var request = {
            name: this.form.lastname + ' ' + this.form.firstname + ' ' + this.form.surname,
            phone: '+7' + this.form.phone.replace(/\D+/g, ''),
            email: this.form.email,
            password: this.form.password,
            type: this.form.usertype
        }
        const requestStr = JSON.stringify(request)
        axios.post (this.$root.api_url + 'user/',  requestStr, {
            headers: {
                'Content-Type': 'application/json'
            }
            })  
            .then((response) => {
                this.$q.notify({
                    message: this.$t('regsucc'),
                    type: 'positive',
                    icon: 'thumb_up'
                })
                this.$store.commit('unset_token')
                this.$store.commit('unset_auth')
                this.$router.push('/auth')

            })
            .catch(() => {
                this.$q.notify({
                    message: this.$t('errors.regerr'),
                    type: 'negative',
                    icon: 'report_problem'
                })
            })
        },
    }
}
</script>

<style scoped>
.divimage{
    background-image: url('../assets/background.jpg');
    background-repeat: repeat-y; /* for vertical repeat */
    background-repeat: repeat-x; /* for horizontal repeat */
    background-size: 100%;
}
.auth{
    background-color: white;
    border: 1px solid green;
    width: 500px; 
    height: 430px;
    border-radius: 5px;
    position: absolute;
    top: 30%;    
}
</style>


